import axios from 'axios';
import Subtask, { SubtaskWithStudentSubmissions } from '@/models/subtask';
import store from '@/store';
import { applyErrorHandlers } from '@/decorators/applyErrorHandler';

const API_SUBTASK_URL = process.env.VUE_APP_API_URL+"/subtasks";
const API_FILE_URL = process.env.VUE_APP_API_URL+"/files";

export default class SubtaskController {
  // Fetch all subtasks
  static async fetchSubtasks() {
    const response = await axios.get(`${API_SUBTASK_URL}/get_subtasks`);
    console.log('Subtasks fetched successfully:', response.data);
    return response.data.map(subtask => new Subtask(subtask));
  }

  // Fetch subtask by ID
  static async fetchSubtaskById(subtaskId) {
    const response = await axios.get(`${API_SUBTASK_URL}/get_subtask_by_id/${subtaskId}`);
    console.log('Subtask fetched successfully:', response.data);
    return new Subtask(response.data);
  }

  // Fetch subtasks by homework ID
  static async fetchSubtasksByHomeworkId(homeworkId) {
    const response = await axios.get(`${API_SUBTASK_URL}/get_subtasks_by_homework_id/${homeworkId}`);
    return response.data.map(subtask => new Subtask(subtask));
  }

  // Fetch subtask by ID with students submissions
  static async fetchSubtaskByIdWithStudentsSubmissions(subtaskId) {
    const studentId = store.getters.userId;
    const response = await axios.get(`${API_SUBTASK_URL}/get_subtask_by_id_with_student_submissions/${subtaskId}/${studentId}`);
    return new SubtaskWithStudentSubmissions(response.data);
  }

  // Create a new subtask
  static async createSubtask(subtaskData) {
    Subtask.validate(subtaskData);
    const response = await axios.post(`${API_SUBTASK_URL}/create_subtask`, subtaskData);
    return new Subtask(response.data);
  }

  // Update an existing subtask
  static async updateSubtask(subtaskId, subtaskData) {   
    Subtask.validate(subtaskData);
    const response = await axios.put(`${API_SUBTASK_URL}/update_subtask/${subtaskId}`, subtaskData);
    return new Subtask(response.data);
  }
  
  // Delete a subtask by ID
  static async deleteSubtask(subtaskId) {
    const response = await axios.delete(`${API_SUBTASK_URL}/delete_subtask/${subtaskId}`);
    return response.data;
  }
  
  // Upload files
  static async uploadFiles(endpoint, subtaskId, homeworkId, formData) {
    const semester_id = store.getters.semesterId;
    const response = await axios.post(`${API_FILE_URL}/${endpoint}/${semester_id}/${homeworkId}/${subtaskId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response;
  }

  // Download a file
  static async downloadFile(filePath) {
    const response = await axios.get(`${API_FILE_URL}/download_file`, {
      params: { relative_file_path: filePath },
      responseType: 'blob'
    });
    return response;
  }

  // Download multiple files
  static async downloadFiles(filePaths) {
    console.log('Downloading files:', filePaths);
    const response = await axios.post(`${API_FILE_URL}/download_files`, filePaths, { responseType: 'blob' });
    return response;
  }

  // Delete a file
  static async deleteFile(subtaskId, filePath) {
    const response = await axios.delete(`${API_FILE_URL}/delete_file_from_subtask/${subtaskId}`, {
      params: { relative_file_path: filePath }
    });
    return response.data;
  }
}

applyErrorHandlers(SubtaskController);